import PubSub from "pubsub-js";
import OverlayScrollBars from "overlayscrollbars/js/jquery.overlayScrollbars.js";
import Slick from "slick-carousel";
import Equalizer from "../../../../scripts/classes/Equalizer";
import gsap from 'gsap';

var ModalUnitDetail = function (options) {

  this.options = {
    $el: false,
    baseClass: 'comp-ModalUnitDetail',
  };

  $.extend(true, this.options, options);

};

ModalUnitDetail.prototype.init = function () {

  var self = this;

  this.pageUrl = window.location.href;

  this.$modal = this.options.$el.find(`.${self.options.baseClass}__modal`);
  this.$modalContent = this.$modal.find(`.${self.options.baseClass}__modalContent`);
  this.$closeXSpans = self.options.$el.find(`.${self.options.baseClass}__closeX span`);
  this.$loader = self.options.$el.find(`.${self.options.baseClass}__loader`);

  this.galleryId = self.options.$el.data('galleryId');

  this.$notFoundText = self.options.$el.find(`.${self.options.baseClass}__notFoundText`);
  this.$unitInfoWrapper = self.options.$el.find(`.${self.options.baseClass}__unitInfoWrapper`);

  // clone our elements to use as templates to fill out with data
  this.$leftContent = this.$unitInfoWrapper.find(`.${self.options.baseClass}__unitInfoWrapper__left__content`);
  this.$leftContentTemplate = this.$leftContent.clone();

  this.$rightContent = this.$unitInfoWrapper.find(`.${self.options.baseClass}__unitInfoWrapper__right__content`);
  this.$rightContentTemplate = this.$rightContent.clone();

  this.startLoadTime = 0;

  this.activeUnitTitle = '';
  this.activeUnitApplyUrl = '';

  // slider
  this.$imageSlider = this.options.$el.find(`.${self.options.baseClass}__imageSlider`);

  // initialize image slider
  this.$imageSlider.slick({
    arrows: false,
    fade: true,
    speed: 750,
    autoplay: true,
    autoplaySpeed: 5000,
  });

  // previous/next buttons
  this.options.$el.find(`.${self.options.baseClass}__previousButton`).on('click', function () {
    self.$imageSlider.slick('slickPrev');
  });

  this.options.$el.find(`.${self.options.baseClass}__nextButton`).on('click', function () {
    self.$imageSlider.slick('slickNext');
  });

  this.$imageSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {

    self.updateSlideCounter(nextSlide + 1);

  });

  // set up equalizer to set height of slide counter container because children are position: absolute
  this.slideCounterEq = new Equalizer(self.options.$el.find(`.${self.options.baseClass}__slideCounter, .${self.options.baseClass}__slideNumber`));

  this.slideCounterEq.equalizeHeights();

  PubSub.subscribe("resized", function () {
    self.slideCounterEq.equalizeHeights();
  });

  // overlay scroll bars
  // note that we call overlayScrollbars() twice here, once to initialize and once to return the instance
  this.overlayScrollbarsInstance = this.options.$el.find(`.${self.options.baseClass}__modal`).overlayScrollbars({
    className: "os-theme-dark"
  }).overlayScrollbars();

  this.initAnimationTimelines();

  this.options.$el.find(`.${self.options.baseClass}__closeX`).on('click', function (e) {

    e.stopPropagation(); // prevent our overlay background click event from triggering the fast close timeline
    self.close();

  });

  this.options.$el.on('click', function () {

    self.fastClose();

  });

  this.$modal.on('click', function (e) {

    e.stopPropagation();

  });

  this.$loader.on('click', function (e) {

    e.stopPropagation();

  });

  // pubsub events
  PubSub.subscribe('ModalUnitDetail:open', function (msg, unitId) {
    console.log('open modal');
    self.open(unitId);

  });

  PubSub.subscribe('ModalUnitDetail:close', function () {

    self.close();

  });

  PubSub.subscribe('ModalUnitDetail:populateContent', function (msg, data) {

    self.populateContent(data);

  });

  PubSub.subscribe('ModalUnitDetail:notFound', function () {

    self.showNotFoundText();

  });

  window.modalUnitDetailLoaded = true;

  // Before the apply form is submitted, add the unit specific info.
  // We do this on submission because if we do it elsewhere it will trigger a warning
  // when the user tries to leave the page.
  var $form = this.options.$el.find("form");

  $form.on('onBeforeFormieSubmit', function (e) {
    $form.find(`[name="fields[unit]"]`).val(self.activeUnitTitle);
    $form.find(`[name="fields[applyUrl]"]`).val(self.activeUnitApplyUrl);
  });

};

ModalUnitDetail.prototype.populateContent = function (data) {

  var self = this;

  console.log('populate content');
  console.log(data);
  console.log(this.$leftContent);

  this.setUrlState(data.url);

  // left content
  var $newLeftContent = this.$leftContentTemplate.clone();

  // details

  // beds
  if (data.unitBeds) {
    $newLeftContent.find(`.${self.options.baseClass}__details__detail--beds .${self.options.baseClass}__details__detail__value`).html(data.unitBeds);

    if (!isNaN(data.unitBeds)) {
      $newLeftContent.find(`.${self.options.baseClass}__details__detail--beds .${self.options.baseClass}__details__detail__value`).append(' bed');
    }

  } else if (data.unitFloorPlan[0].floorPlanBeds) {

    $newLeftContent.find(`.${self.options.baseClass}__details__detail--beds .${self.options.baseClass}__details__detail__value`).html(data.unitFloorPlan[0].floorPlanBeds);

    if (!isNaN(data.unitFloorPlan[0].floorPlanBeds)) {
      $newLeftContent.find(`.${self.options.baseClass}__details__detail--beds .${self.options.baseClass}__details__detail__value`).append(' bed');
    }

  } else {
    $newLeftContent.find(`.${self.options.baseClass}__details__detail--beds`).remove();
  }

  // baths
  if (data.unitBaths) {
    $newLeftContent.find(`.${self.options.baseClass}__details__detail--baths .${self.options.baseClass}__details__detail__value`).html(data.unitBaths);

    if (!isNaN(data.unitBaths)) {
      $newLeftContent.find(`.${self.options.baseClass}__details__detail--baths .${self.options.baseClass}__details__detail__value`).append(' bath');
    }

  } else if (data.unitFloorPlan[0].floorPlanBaths) {

    $newLeftContent.find(`.${self.options.baseClass}__details__detail--baths .${self.options.baseClass}__details__detail__value`).html(data.unitFloorPlan[0].floorPlanBaths);

    if (!isNaN(data.unitFloorPlan[0].floorPlanBaths)) {
      $newLeftContent.find(`.${self.options.baseClass}__details__detail--baths .${self.options.baseClass}__details__detail__value`).append(' bath');
    }

  } else {
    $newLeftContent.find(`.${self.options.baseClass}__details__detail--baths`).remove();
  }

  // square feet
  if (data.unitSquareFeet) {
    $newLeftContent.find(`.${self.options.baseClass}__details__detail--squareFeet .${self.options.baseClass}__details__detail__value`).html(data.unitSquareFeet + ' sqft.');
  } else if (data.unitFloorPlan[0].floorPlanSquareFeet) {
    $newLeftContent.find(`.${self.options.baseClass}__details__detail--squareFeet .${self.options.baseClass}__details__detail__value`).html(data.unitFloorPlan[0].floorPlanSquareFeet + ' sqft.');
  } else {
    $newLeftContent.find(`.${self.options.baseClass}__details__detail--squareFeet`).remove();
  }

  // title
  if (data.title) {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__title`).html(data.title);
    self.activeUnitTitle = data.title;
  } else {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__title`).remove();
    self.activeUnitTitle = '';
  }

  // cost
  if (data.unitCost) {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__cost`).html("Rent: " + data.unitCost);
  } else {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__cost`).remove();
  }

  // fixed charges
  if (data.unitFixedCharges) {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__fixedCharges`).html("Fixed Charges: " + data.unitFixedCharges);
  } else {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__fixedCharges`).html("Fixed Charges: $0");
  }

  // total rent
  if (data.unitTotalRent) {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__totalRent`).html("Total Rent: " + data.unitTotalRent);
  } else if (data.unitCost) {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__totalRent`).html("Total Rent: " + data.unitCost);
  } else {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__totalRent`).remove();
  }

  // note
  if (data.unitNote) {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__note`).html(data.unitNote);
  } else {
    $newLeftContent.find(`.${self.options.baseClass}__basicInfo__note`).remove();
  }

  // availability
  self.options.$el.find(`.${self.options.baseClass}__formWrapper`).removeClass(`${self.options.baseClass}__formWrapper--inactive`);

  if (!data.unitActive) {
    self.options.$el.find(`.${self.options.baseClass}__formWrapper`).addClass(`${self.options.baseClass}__formWrapper--inactive`);
  }

  // update dom element
  this.$leftContent.empty().append($newLeftContent.html());

  // right content
  var $newRightContent = this.$rightContentTemplate.clone();

  // image


  // if (data.unitImages.length > 0) {
  // 	$newRightContent.find(`.${self.options.baseClass}__unitImageWrapper__image`).attr('src', data.unitImages[0].url);
  // }
  // else {
  // 	$newRightContent.find(`.${self.options.baseClass}__unitImageWrapper__image`).remove();
  // }

  // overview
  if (data.unitIntroText) {
    $newRightContent.find(`.${self.options.baseClass}__overview__textContent`).html('<p>' + data.unitIntroText + '</p>');
  } else {
    $newRightContent.find(`.${self.options.baseClass}__overview`).remove();
  }

  // amenities
  $newRightContent.find(`.${self.options.baseClass}__detailsListWrapper--amenities .${self.options.baseClass}__detailsListWrapper__list`).empty();

  if (data.unitAmenities.length < 1) {
    $newRightContent.find(`.${self.options.baseClass}__detailsListWrapper--amenities`).remove();
  } else {

    for (var i = 0; i < data.unitAmenities.length; i++) {
      $newRightContent.find(`.${self.options.baseClass}__detailsListWrapper--amenities .${self.options.baseClass}__detailsListWrapper__list`).append(`<li>` + data.unitAmenities[i].amenityText + `</li>`);
    }

  }

  // update dom element
  this.$rightContent.empty().append($newRightContent.html());

  // set apply now url variable for use in the form
  if (data.unitApplyUrl) {
    self.activeUnitApplyUrl = data.unitApplyUrl;
  } else {
    self.activeUnitApplyUrl = '';
  }










  // gallery

  // assemble our slides into a JSON object that can be passed to the gallery
  var galleryItems = [];

  let images;

  if (data.unitImages.length) {
    images = data.unitImages;
  } else if (data.unitFloorPlan.length && data.unitFloorPlan[0].floorPlanImage.length) {
    images = data.unitFloorPlan[0].floorPlanImage;
  }

  for (var i = 0; i < images.length; i++) {

    var imageUrl = '';

    // imager x has limited options for graph ql queries, and to use a named transform (and create transforms ahead of runtime)
    // you can only access the image using srcset. We're just using a background image, so if srcset is what we're provided
    // here we grab the first url from the srcset string.
    if (images[i].srcset) {
      imageUrl = images[i].srcset.split(' ')[0];
    } else if (images[i].url) {
      imageUrl = images[i].url;
    }

    if (imageUrl) {

      galleryItems.push({
        type: 'image',
        url: imageUrl
      });

    }

  }

  // splice the youtube video into the second slide if it exists
  if (data.unitYoutubeVideoId) {

    galleryItems.splice(1, 0, {
      type: 'youtube',
      videoId: data.unitYoutubeVideoId
    });

  }

  PubSub.publish('MediaGallery:updateSlides', [this.galleryId, galleryItems]);

  if (galleryItems.length == 1 && galleryItems[0].type != "image") {
    // our only slide is a youtube video, there are no images
    self.doneLoading();
  } else if (galleryItems.length > 0) {

    $(`<img src="${galleryItems[0].url}">`).on('load', function () {
      $(this).remove(); // prevent memory leaks
      // trigger our done loading method
      self.doneLoading();
    });

  } else {
    // trigger our done loading method
    self.doneLoading();
  }







  /*
  if (data.unitImages.length > 0) {

  	$(`<img src="${data.unitImages[0].url}">`).on('load', function() {
  		$(this).remove(); // prevent memory leaks
  		// trigger our done loading method
  		self.doneLoading();
  	});

  }
  else {
  	// trigger our done loading method
  	self.doneLoading();
  }
  */

};

ModalUnitDetail.prototype.updateSlideCounter = function (slideNumber) {

  var self = this;

  this.options.$el.find(`.${self.options.baseClass}__slideNumber`).removeClass(`${self.options.baseClass}__slideNumber` + '--active');

  this.options.$el.find(`.${self.options.baseClass}__slideNumber` + '[data-slide-number="' + slideNumber + '"]').addClass(`${self.options.baseClass}__slideNumber` + '--active');

};

ModalUnitDetail.prototype.initAnimationTimelines = function () {

  var self = this;

  // open to loading state
  this.openLoadingTimeline = gsap.timeline({
      paused: true,
    })
    .add(function () {
      self.overlayScrollbarsInstance.scroll([0, 0]);
    })
    .set(self.$unitInfoWrapper, {
      display: "flex"
    })
    .set(self.$notFoundText, {
      display: "none"
    })
    .set(self.$modalContent, {
      opacity: 0,
      scale: 0.95,
    })
    .set(self.options.$el, {
      visibility: 'visible',
      zIndex: 2001,
    })
    .set(self.$loader, {
      zIndex: 2
    })
    .to(self.options.$el, {
      duration: 0.45,
      ease: "power1.out",
      opacity: 1,
    })
    .to(self.$modal, {
        duration: 0.45,
        ease: "power1.out",
        opacity: 1,
        y: 0,
      },
      "<"
    )
    .to(self.$loader, {
        duration: 0.45,
        ease: "power1.out",
        opacity: 1,
      },
      "<"
    )
    // close x
    .from(self.$closeXSpans, {
      duration: 0.25,
      width: 0,
      ease: "power3.out"
    })
    .from(self.$closeXSpans, {
        duration: 0.25,
        rotate: 0,
        ease: "power1.inOut"
      },
      ">-0.1"
    );

  // close
  this.closeTimeline = gsap.timeline({
      paused: true,
    })
    .to(self.$closeXSpans, {
      duration: 0.25,
      rotate: 0,
      ease: "power1.inOut"
    })
    .to(self.$closeXSpans, {
        duration: 0.25,
        width: 0,
        ease: "power3.in"
      },
      ">-0.1"
    )
    .to(self.options.$el, {
        duration: 0.45,
        ease: "power1.out",
        opacity: 0,
      },
      ">-0.1"
    )
    .set(self.options.$el, {
      visibility: 'hidden',
      zIndex: -1,
    });

  // fast close
  this.fastCloseTimeline = gsap.timeline({
      paused: true,
    })
    .to(self.options.$el, {
        duration: 0.45,
        ease: "power1.out",
        opacity: 0,
      },
      ">-0.1"
    )
    .set(self.options.$el, {
      visibility: 'hidden',
      zIndex: -1,
    });

};

/*
 * We init this timeline separately, because it needs to be reinited every time it runs so that the
 * starting values are accurate.
 */
ModalUnitDetail.prototype.initDoneLoadingAnimation = function () {

  var self = this;

  // done loading, show content
  this.doneLoadingTimeline = gsap.timeline({
      paused: true,
    })
    .to(self.$loader, {
      duration: 0.45,
      ease: "power1.out",
      opacity: 0,
    })
    .set(self.$loader, {
      zIndex: -1
    })
    .to(self.$modalContent, {
        duration: 0.45,
        ease: "power1.out",
        height: "auto"
      },
      "<"
    )
    .add(function () {
      // scrollbars need to be shown/hidden via css class, because they are added dynamically via third-party plugin
      self.options.$el.addClass(`${self.options.baseClass}--showScrollbars`);
    })
    .to(self.$modalContent, {
      duration: 0.45,
      ease: "power1.out",
      opacity: 1,
      scale: 1,
    });

};

/*
 * We init this timeline separately, because it needs to be reinited every time it runs so that the
 * starting values are accurate.
 */
ModalUnitDetail.prototype.initNotFoundAnimation = function () {

  console.log('init not found animation');

  var self = this;

  this.notFoundTimeline = gsap.timeline({
      paused: true,
    })
    .to(self.$loader, {
      duration: 0.45,
      ease: "power1.out",
      opacity: 0,
    })
    .set(self.$loader, {
      zIndex: -1
    })
    .set(self.$notFoundText, {
      display: "block",
    })
    .set(self.$unitInfoWrapper, {
      display: "none"
    })
    .to(self.$modalContent, {
        duration: 0.45,
        ease: "power1.out",
        height: "auto"
      },
      "<"
    )
    .add(function () {
      // scrollbars need to be shown/hidden via css class, because they are added dynamically via third-party plugin
      self.options.$el.addClass(`${self.options.baseClass}--showScrollbars`);
    })
    .to(self.$modalContent, {
      duration: 0.45,
      ease: "power1.out",
      opacity: 1,
      scale: 1,
    });

};

ModalUnitDetail.prototype.open = function (unitId) {

  var self = this;

  $('body').addClass('disable-scroll');

  gsap.set(self.$modalContent, {
    height: self.$modalContent.outerHeight()
  });

  // scrollbars need to be shown/hidden via css class, because they are added dynamically via third-party plugin
  self.options.$el.removeClass(`${self.options.baseClass}--showScrollbars`);

  this.openLoadingTimeline.restart();

  this.startLoadTime = Date.now();

};

ModalUnitDetail.prototype.setUrlState = function (url) {

  var self = this;
  console.log(url);
  // set our url so the user can copy/paste
  var state = {};
  var title = '';
  var url = new URL(url);
  // url.searchParams.set('unitDetail', unitId);
  window.history.replaceState(state, title, url);

};

ModalUnitDetail.prototype.clearUrlState = function () {

  // clear our url
  var state = {};
  var title = '';
  window.history.replaceState(state, title, this.pageUrl);

};

ModalUnitDetail.prototype.close = function () {

  PubSub.publish('ModalUnitDetail:Closing');

  $('body').removeClass('disable-scroll');

  this.clearUrlState();

  this.closeTimeline.restart();

};

ModalUnitDetail.prototype.fastClose = function () {

  PubSub.publish('ModalUnitDetail:Closing');

  $('body').removeClass('disable-scroll');

  this.clearUrlState();

  this.fastCloseTimeline.restart();

};

ModalUnitDetail.prototype.doneLoading = function () {

  var self = this;

  // make sure we load for a couple seconds before showing content to prevent loader flashing
  if ((Date.now() - this.startLoadTime) < 2000) {

    window.setTimeout(function () {
      self.doneLoading();
    })

  } else {
    this.initDoneLoadingAnimation();
    this.doneLoadingTimeline.restart();
  }


};

ModalUnitDetail.prototype.showNotFoundText = function () {

  var self = this;

  this.initNotFoundAnimation();
  this.notFoundTimeline.restart();

  // this.options.$el.addClass(`${self.options.baseClass}--notFound`)

};

ModalUnitDetail.prototype.hideNotFoundText = function () {

  var self = this;

  // this.options.$el.removeClass(`${self.options.baseClass}--notFound`)

};

export default ModalUnitDetail;
